import { render, staticRenderFns } from "./ComissionAffiliate.vue?vue&type=template&id=6b680174&scoped=true"
import script from "./ComissionAffiliate.vue?vue&type=script&lang=js"
export * from "./ComissionAffiliate.vue?vue&type=script&lang=js"
import style0 from "./ComissionAffiliate.vue?vue&type=style&index=0&id=6b680174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b680174",
  null
  
)

export default component.exports